const META_PIXEL_ID = '4516239645287000';

let initialized = false;

/**
 * Loads the Meta Pixel script and fires the initial PageView.
 * Only runs once — safe to call multiple times.
 * Must be called ONLY after cookie consent is accepted.
 */
export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  /* eslint-disable */
  const n: any = (window as any).fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!(window as any)._fbq) (window as any)._fbq = n;
  n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
  /* eslint-enable */

  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode?.insertBefore(t, s);

  window.fbq!('init', META_PIXEL_ID);
  window.fbq!('track', 'PageView');
}

/**
 * Tracks a Meta Pixel event. No-op if pixel hasn't been loaded (consent not given).
 */
export function trackPixel(event: string, params?: Record<string, unknown>) {
  if (window.fbq) {
    window.fbq('track', event, params);
  }
}
